<div class="container">
  <h1>White Label Settings</h1>
  <div class="inner">
    <router-outlet></router-outlet>
  </div>

</div>
